import GraphqlBuilder, { graphqlOptions } from "utils/request/graphql/builder";
import _ from "lodash";
import MutationBuildingToLunchOptions from 'graphql/mutations/MutationBuildingToLunchOptions'

export const MutateToLunchOptionTables = {
	BUILDING: 'building',
	//FLOOR: 'floor',
	//ROOM: 'room',
	//TABLE: 'table',
}

export const lunchOptionToGuid = ( table ) => {
	switch( table ) {
		case MutateToLunchOptionTables.BUILDING:
			return 'building_guid';
		
		//case MutateToLunchOptionTables.FLOOR:
		//	return 'floor_guid';
		//
		//case MutateToLunchOptionTables.ROOM:
		//	return 'room_guid';
		//
		//case MutateToLunchOptionTables.TABLE:
		//	return 'table_guid';
		
		default:
			return null;
	}
}

export default class MutateToLunchOption {
	
	static log( value ) {
		console.prefix('MutateToLunchOption', value );
	}
	
	static mutate = ( table, guid, values, { callbackSuccess = null, callbackError = null, callbackStart = null } = {} ) => {
		const builder = new GraphqlBuilder({
			[ graphqlOptions.processVariables ]: false
		});
		
		let mutation = null;
		let mutationKey = lunchOptionToGuid( table );
		switch( table ) {
			case MutateToLunchOptionTables.BUILDING:
				mutation = MutationBuildingToLunchOptions;
				break;
				
			//case MutateToLunchOptionTables.FLOOR:
			//	mutation = MutateToLunchOptionTables;
			//	break;
			//
			//case MutateToLunchOptionTables.ROOM:
			//	mutation = MutationRoomToTimeslot;
			//	break;
			//
			//case MutateToLunchOptionTables.TABLE:
			//	mutation = MutationTableToTimeslot;
			//	break;
		}
		
		// No mutation? Error..
		if( mutation === null ) {
			this.onError( {}, callbackError );
			return;
		}
		
		builder.addQuery( `mutation_${table}_to_lunch_option`, mutation, {
			[ mutationKey ]: guid,
			lunch_option_guid: values,
		} );
		
		builder.setOnStart( callbackStart )
		builder.setOnSuccess( ( result ) => {
			this.onSuccess( result, callbackSuccess );
		});
		builder.setOnError( (result) => {
			this.onSuccess( result, callbackError );
		} );
		
		if( builder.queries.length > 0 ) {
			builder.execute();
			return;
		}
		
		this.onSuccess( {}, callbackSuccess );
	}
	
	/**
	 *
	 * @param result
	 * @param callback
	 */
	static onSuccess = ( result, callback ) => {
		if( _.isFunction( callback ) ) {
			callback( result );
		}
	}
	
	/**
	 *
	 * @param result
	 * @param callback
	 */
	static onError = ( result, callback ) => {
		if( _.isFunction( callback ) ) {
			callback( result );
		}
	}
}
